// Bottom-sheet opened by tapping the user chip: view the other athlete (read-only),
// switch user, or sign out.

import { activeUser, label, login, logout, setViewing, isViewingSelf, USERS, userColor } from '../lib/auth.js';
import { confirmBox } from './dialog.js';
import { go } from '../router.js';

let activeOverlay = null;

export function rerenderRoute() { window.dispatchEvent(new Event('hashchange')); }

export function openAccountMenu() {
  if (activeOverlay) close();
  const me = activeUser();
  const others = USERS.filter((u) => u !== me);
  const viewingOther = !isViewingSelf();

  const overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[100] flex items-end justify-center bg-black/30';
  const row = (action, text, extra = '', cls = 'text-ink') => `<button data-action="${action}" ${extra} class="grit-row w-full text-left px-4 min-h-[52px] text-[17px] ${cls} border-t border-hairline first:border-0">${text}</button>`;
  overlay.innerHTML = `
    <div class="grit-sheet">
      <div class="grit-sheet-handle"></div>
      <div class="flex items-center gap-3 mb-5">
        <span class="w-12 h-12 rounded-full flex items-center justify-center text-white text-[20px] font-semibold flex-none" style="background:${userColor(me).deep}">${label(me).slice(0, 1)}</span>
        <div><div class="text-[20px] font-bold text-ink leading-tight">${label(me)}</div><div class="text-[15px] text-inksoft">Signed in</div></div>
      </div>
      <div class="bg-pagebg rounded-2xl overflow-hidden">
        ${viewingOther
          ? row('self', 'Back to my training', '', 'text-grit font-semibold')
          : others.map((o) => row('view', `View ${label(o)}'s training`, `data-user="${o}"`)).join('')}
        ${others.map((o) => row('switch', `Switch to ${label(o)}`, `data-user="${o}"`)).join('')}
        ${row('refresh', 'Refresh data')}
      </div>
      <div class="bg-pagebg rounded-2xl overflow-hidden mt-3">${row('signout', 'Sign out', '', 'text-danger')}</div>
      <button data-action="cancel" class="grit-btn-quiet mt-3">Cancel</button>
    </div>`;

  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  overlay.querySelector('[data-action="cancel"]').onclick = close;
  overlay.querySelectorAll('[data-action="view"]').forEach((btn) => {
    btn.onclick = () => { setViewing(btn.dataset.user); close(); go('home'); rerenderRoute(); };
  });
  const selfBtn = overlay.querySelector('[data-action="self"]');
  if (selfBtn) selfBtn.onclick = () => { setViewing(me); close(); rerenderRoute(); };
  overlay.querySelectorAll('[data-action="switch"]').forEach((btn) => {
    btn.onclick = () => { close(); login(btn.dataset.user); go('home'); rerenderRoute(); };
  });
  overlay.querySelector('[data-action="refresh"]').onclick = () => { close(); location.reload(); };
  overlay.querySelector('[data-action="signout"]').onclick = async () => { close(); if (await confirmBox({ title: 'Sign out?', confirmLabel: 'Sign out', danger: true })) { logout(); location.hash = ''; location.reload(); } };

  document.body.appendChild(overlay);
  activeOverlay = overlay;
}

function close() {
  if (activeOverlay) { activeOverlay.remove(); activeOverlay = null; }
}
